import { useEffect, useState } from "react";
import AidApplication from "./AidApplication";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { getStoredToken } from "../auth";
import { getApiUrl } from "../api";
import "../styles/partner-application.css";

const apiBase = getApiUrl("/api");

async function loadInvitation(secureToken) {
  const url = new URL(`${apiBase}/BoardMemberInvite.ashx`);
  url.searchParams.set("token", secureToken);
  const token = getStoredToken();
  const response = await fetch(url, {
    credentials: "include",
    headers: { Accept: "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) throw new Error(payload.message || "Unable to open the board member application.");
  return payload.data;
}

function verifyWithUaePass() {
  const returnTo = `${window.location.pathname}${window.location.search}`;
  window.sessionStorage.setItem("tarahumAuthReturnPath", returnTo);
  window.location.assign(`/login?returnTo=${encodeURIComponent(returnTo)}`);
}

export default function BoardMemberApplication({ language = "en" }) {
  const secureToken = new URLSearchParams(window.location.search).get("token") || "";
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!secureToken) { setError("The board member application link is missing or invalid."); return; }
    loadInvitation(secureToken).then(setInvite).catch((reason) => setError(reason.message));
  }, [secureToken]);

  if (invite) return <AidApplication language={language} partnerContext={{ ...invite, token: secureToken, originCode: "BOARD_MEMBER", partnerName: invite.boardMemberName || "Board Member", boardMemberApiBase: apiBase }} />;

  const needsSignIn = /sign in|profile|uae pass|account/i.test(error);
  return <><Header /><main className="partner-application-page"><section className="partner-application-shell"><div className="partner-access-card">
    <div className="partner-access-icon">✓</div>
    <h1>{error ? "Applicant verification required" : "Opening your application…"}</h1>
    <p>{error || "Verifying your Tarahum profile and secure board member invitation."}</p>
    {needsSignIn ? <button type="button" onClick={verifyWithUaePass}>Sign in / Verify with UAE PASS</button> : null}
  </div></section></main><Footer /></>;
}
